import { Box } from '@mui/material';
import PreviousOrdersTable from './PreviousOrdersTable';

const PreviousOrders = () => {
	return (
		<Box className="mb-6 w-full">
			<PreviousOrdersTable />
		</Box>
	);
};

export default PreviousOrders;
